import Vue from 'vue';
import { formatDate } from '@/utils/dateUtils';

Vue.filter('utcSecondsToDateTime', function (seconds: number, format: string | undefined) {
  if (seconds && !isNaN(seconds)) {
    const date = new Date(seconds * 1000);
    format = format || 'yyyy-MM-dd HH:mm:ss';
    return formatDate(date, format);
  }

  return seconds;
});